export default "__VITE_ASSET__7q4o9bh7__"